import { render, staticRenderFns } from "./addUserInfoTwo.vue?vue&type=template&id=636f5cbc&scoped=true"
import script from "./addUserInfoTwo.vue?vue&type=script&lang=js"
export * from "./addUserInfoTwo.vue?vue&type=script&lang=js"
import style0 from "./addUserInfoTwo.vue?vue&type=style&index=0&id=636f5cbc&prod&lang=scss&scoped=true"
import style1 from "./addUserInfoTwo.vue?vue&type=style&index=1&id=636f5cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f5cbc",
  null
  
)

export default component.exports